(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('copyright', {
            parent: 'entity',
            url: '/copyright?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.copyright.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/copyright/copyrights.html',
                    controller: 'CopyrightController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('copyright');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('copyright-detail', {
            parent: 'copyright',
            url: '/copyright/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.copyright.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/copyright/copyright-detail.html',
                    controller: 'CopyrightDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('copyright');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Copyright', function($stateParams, Copyright) {
                    return Copyright.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'copyright',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('copyright-detail.edit', {
            parent: 'copyright-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/copyright/copyright-dialog.html',
                    controller: 'CopyrightDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Copyright', function(Copyright) {
                            return Copyright.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('copyright.new', {
            parent: 'copyright',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/copyright/copyright-dialog.html',
                    controller: 'CopyrightDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('copyright', null, { reload: 'copyright' });
                }, function() {
                    $state.go('copyright');
                });
            }]
        })
        .state('copyright.edit', {
            parent: 'copyright',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/copyright/copyright-dialog.html',
                    controller: 'CopyrightDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Copyright', function(Copyright) {
                            return Copyright.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('copyright', null, { reload: 'copyright' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('copyright.delete', {
            parent: 'copyright',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/copyright/copyright-delete-dialog.html',
                    controller: 'CopyrightDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Copyright', function(Copyright) {
                            return Copyright.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('copyright', null, { reload: 'copyright' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
